import config from 'shared/config';
import dismissNotification from 'redux/domain/Notifications/actions';
import InactivityTimeout from 'storis-inactivity-timeout';
import { AccessToken, Storage } from 'storis-jwt-auth';
import { closeCancelConfirmModal } from 'redux/domain/App';
import { createNotification } from 'redux/domain/Notifications/creators';
import { setLoggedOut } from 'redux/domain/User/Authentication/actions';

// defaults
const activityInterval = 1000;
const idlePeriod = config.TIMEOUT.idle * 1000;
const warningSeconds = config.TIMEOUT.warning;
const warningPeriod = warningSeconds * 1000;
let warningMessage = `You will be redirected to restart this process due to inactivity in ${warningSeconds} seconds`;

class ReduxInactivityTimeout {
	static configure = (store, history) => {
		const inactivity = new InactivityTimeout({
			activityInterval,
			idlePeriod,
			warningPeriod,
			warningCallback: ReduxInactivityTimeout.warning(store),
			timeoutCallback: ReduxInactivityTimeout.timeout(store, history),
			resumeActivityCallback: ReduxInactivityTimeout.resume(store),
		});

		inactivity.addEventListeners();
		inactivity.startActivityInterval();
	};

	static resume = store => () => {
		ReduxInactivityTimeout.dismissInactiveNotification(store);
	};

	static timeout = (store, history) => () => {
		ReduxInactivityTimeout.dismissInactiveNotification(store);
		store.dispatch(closeCancelConfirmModal());

		// If not on welcome page when timing out, reload
		if (window.location.href !== `${config.ESTORIS_BASE_PATH}/now`) {
			window.location.href = `${config.ESTORIS_BASE_PATH}/now`
		}

		if (AccessToken.isAcceptable()) {
			Storage.clear();
			store.dispatch(setLoggedOut());
		}
	};

	static warning = (store, message = warningMessage) => () => {
		warningMessage = message;

		// Prevent warning from displaying on welcome page
		if (window.location.href !== `${config.ESTORIS_BASE_PATH}/now`) {
			store.dispatch(createNotification(message, null));
		}
	};

	static dismissInactiveNotification = store => {
		const notification = store
			.getState()
			.notifications.get('messages')
			.first();
		if (notification && notification.message === warningMessage) {
			store.dispatch(dismissNotification());
		}
	};
}

export default ReduxInactivityTimeout;
